const subscription = {
  subscribe: "Subscribe",
  demoState: "Demo",
  ongoingState: "Subscribed",
  expiryState: "Expired",
  resubscribe: "Renew my subscription",
  extendSubscribe: "Extend my subscription until:",
  status: "Status:",
  endsubscription: "Subscription end date:",
  expiryDate: "Expiry date:",
  subscribeTitle: "Content offer",
  subscribeContent:
    "This plan includes unlimited access to all exercises and learning materials for levels A1, A2, B1, and B2 for one year.",
  subscribePrice: "The subscription fee is",
  expiryDateReminder: "Your subscription ends on",
  renewalProposal:
    "To continue using iizenglish, please renew your subscription.",
  renewalOk: "Ok",
  renewalDisable: "Don’t show again",
  renewalAccept: "Renew my subscription",
  resubscribeExtendDate: "Extend my subscription until :",
  remiderSubscriptionModalTitle: "Subscribe now!",
  mySubscription: "My subscription",
  subscription: "Subscription",
};

export default subscription;
